import React from "react";

import Navbar from "./Navbar";
import PhotoLoader from "./PhotoLoader";
import AboutMe from "./AboutMe";
import FactoryAutomationCard from "./FactoryAutomationCard";
import FullstackCard from "./FullstackCard";
import CloudComputingCard from "./CloudComputingCard";

const AboutMePage = () => {
  return (
    <div className="body white-letter centered-text">
      Welcome to my personal website, here you can find information about me, my projects and my interests.
      I hope that this together with my resume can give you a good idea of who I am and what I can offer as profesionits.

      <div className="my-rows">
        <PhotoLoader />
        <AboutMe />
      </div>
      <div className="my-rows">
        <FactoryAutomationCard />
        <FullstackCard />
        <CloudComputingCard />
      </div>
    </div>
  );
};

export default AboutMePage;
